import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Typography,
    IconButton,
    Grid,
    TextField,
} from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import axios from "axios";
import styles from "./FileUploaderModal.module.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { PictureAsPdf as PdfIcon } from "@material-ui/icons";

const FileUploaderModal = ({ imagesArr, entity, entityId, onUpdateFiles }) => {
    const [isOpen, setModalOpen] = useState(false);
    const [images, setImages] = useState(
        imagesArr
            ?.sort((a, b) => a.order - b.order)
            ?.map((image) => ({ url: image.link, fromServer: true })),
    );
    const [errors, setErrors] = useState([]);

    const refreshImages = async () => {
        try {
            const response = await axios.get(
                `/manager/data/${entity}/${entityId}/get_images`,
            );
            const sortedImages =
                response.data?.sort((a, b) => a.order - b.order) || [];
            setImages(
                sortedImages.map((image) => ({
                    url: image.link,
                    fromServer: true,
                })),
            );
            if (onUpdateFiles) {
                onUpdateFiles(sortedImages);
            }
        } catch (error) {
            console.error("Error refreshing images:", error);
            setErrors(["Не удалось получить список файлов"]);
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const newImages = [];
        const newErrors = [];

        files.forEach((file) => {
            const fileType = file.type.split("/")[1];
            if (!["jpeg", "jpg", "png", "webp", "pdf"].includes(fileType)) {
                newErrors.push(`Формат файла ${file.name} не поддерживается.`);
                return;
            }
            if (file.size > 1024 * 1024) {
                newErrors.push(`Размер файла ${file.name} превышает 1МБ.`);
                return;
            }
            newImages.push({
                file,
                url: URL.createObjectURL(file),
                order: images.length + newImages.length + 1,
            });
        });

        setErrors(newErrors);
        setImages((prev) => [...prev, ...newImages]);
    };

    const handleDeleteImage = (index) => {
        setImages(images.filter((_, i) => i !== index));
    };

    const handleSave = async () => {
        const formData = new FormData();
        images.forEach((image, index) => {
            if (image.file) {
                formData.append(`images[${index}]`, image.file);
            } else {
                formData.append(`images[${index}]`, image.url);
            }
        });
        try {
            await axios.post(
                `/manager/data/${entity}/${entityId}/upload_images`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
            );
            refreshImages();
            handleCloseModal(false);
        } catch (error) {
            setErrors(["Произошла ошибка при загрузке. Попробуйте снова."]);
        }
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = (needUpdate = true) => {
        if (needUpdate) {
            refreshImages();
        }
        setModalOpen(false);
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const updatedImages = [...images];
        const [reorderedItem] = updatedImages.splice(result.source.index, 1);
        updatedImages.splice(result.destination.index, 0, reorderedItem);

        setImages(
            updatedImages.map((img, index) => ({ ...img, order: index + 1 })),
        );
    };

    const trimFileName = (filename) => {
        const indexOfQuestionMark = filename.indexOf("?");
        return indexOfQuestionMark !== -1
            ? filename.substring(0, indexOfQuestionMark)
            : filename;
    };

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                onClick={handleOpenModal}
            >
                Загрузить/удалить файлы
            </Button>

            <Modal
                open={isOpen}
                onClose={handleCloseModal}
                className={styles.modal}
            >
                <div className={styles.paper}>
                    {errors.length > 0 && (
                        <Typography className={styles.errorMessages}>
                            {errors.map((error, index) => (
                                <div key={index}>{error}</div>
                            ))}
                        </Typography>
                    )}

                    <input
                        accept="image/jpeg,image/png,image/webp,.pdf"
                        className={styles.hiddenInput}
                        id="image-uploader"
                        multiple
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="image-uploader">
                        <Button
                            className={styles.bottonBlack}
                            variant="contained"
                            color="primary"
                            component="span"
                        >
                            Выбрать изображения или PDF
                        </Button>
                    </label>

                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="images">
                            {(provided) => (
                                <Grid
                                    container
                                    spacing={2}
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {images.map((image, index) => (
                                        <Draggable
                                            key={index}
                                            draggableId={String(index)}
                                            index={index}
                                        >
                                            {(provided) => (
                                                <Grid
                                                    item
                                                    xs={2}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <div
                                                        className={
                                                            styles.imageGrid
                                                        }
                                                    >
                                                        <div>
                                                            <div
                                                                className={
                                                                    styles.imageBtnContainer
                                                                }
                                                            >
                                                                <IconButton
                                                                    className={
                                                                        styles.deleteButton
                                                                    }
                                                                    onClick={() =>
                                                                        handleDeleteImage(
                                                                            index,
                                                                        )
                                                                    }
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </div>
                                                            {image.url.includes(
                                                                ".pdf",
                                                            ) ||
                                                            (image.file &&
                                                                image.file
                                                                    .type ===
                                                                    "application/pdf") ? (
                                                                <div
                                                                    className={
                                                                        styles.pdfContainer
                                                                    }
                                                                >
                                                                    <PdfIcon
                                                                        className={
                                                                            styles.pdfIcon
                                                                        }
                                                                    />
                                                                    <span
                                                                        className={
                                                                            styles.pdfText
                                                                        }
                                                                    >
                                                                        PDF
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={
                                                                        image.url.includes(
                                                                            "data:",
                                                                        )
                                                                            ? image.url
                                                                            : image.url
                                                                    }
                                                                    alt="thumbnail"
                                                                    className={
                                                                        styles.thumbnail
                                                                    }
                                                                />
                                                            )}
                                                            <div>
                                                                <p
                                                                    className={
                                                                        styles.name__images
                                                                    }
                                                                >
                                                                    {image?.fromServer
                                                                        ? trimFileName(
                                                                              image.url
                                                                                  .split(
                                                                                      "/",
                                                                                  )
                                                                                  .pop(),
                                                                          )
                                                                        : trimFileName(
                                                                              image
                                                                                  ?.file
                                                                                  ?.name,
                                                                          )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </Grid>
                            )}
                        </Droppable>
                    </DragDropContext>

                    <div className={styles.buttonsWrapper}>
                        <Button variant="contained" onClick={handleCloseModal}>
                            Назад
                        </Button>
                        <Button
                            variant="contained"
                            className={styles.bottonBlack}
                            color="primary"
                            onClick={handleSave}
                        >
                            Сохранить
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default FileUploaderModal;
